// src/components/home/Offering.jsx
import React, { useState } from 'react';
import qrisPelayanan from '../../assets/images/qris_pelayanan.png';
import qrisPembangunan from '../../assets/images/qris_pembangunan.png';

const Offering = () => {
    const [activeTab, setActiveTab] = useState('pelayanan');

    const qrisList = [
        { id: 'pelayanan', img: qrisPelayanan, title: 'QRIS Dana Pelayanan' },
        { id: 'pembangunan', img: qrisPembangunan, title: 'QRIS Dana Pembangunan' }
    ];

    const activeImage = qrisList.find(item => item.id === activeTab);

    return (
        <section className="px-1 mt-2">
            <div className="max-w-xl mx-auto">
                {/* Tabs */}
                <div className="flex justify-center space-x-4 border-b border-gray-200">
                    {qrisList.map((item) => (
                        <button
                            key={item.id}
                            className={`py-2 px-4 text-sm font-medium ${activeTab === item.id
                                ? 'border-b-2 border-blue-500 text-blue-600'
                                : 'text-gray-500 hover:text-gray-700'
                                }`}
                            onClick={() => setActiveTab(item.id)}
                        >
                            {item.title}
                        </button>
                    ))}
                </div>

                {/* Tab Content */}
                <div className="mt-8 flex justify-center">
                    {activeImage && (
                        <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                            <div className="p-4 flex justify-center">
                                <img
                                    src={activeImage.img}
                                    alt={activeImage.title}
                                    // Mengubah max-w-md menjadi max-w-xs agar gambar lebih kecil
                                    className="w-full max-w-xs rounded-xl border border-gray-300 hover:scale-105 transition-transform duration-300"
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Offering;